import { queryOptions } from '@tanstack/react-query';
import { siteconfigAPIClient } from '../siteconfigAPIClient';
import { SITECONFIG_QUERY_KEYS } from './keys';

export const SITECONFIG_QUERIES = {
  getShippingPolicies: () =>
    queryOptions({
      queryKey: SITECONFIG_QUERY_KEYS.getShippingPolicies(),
      queryFn: () => siteconfigAPIClient.getShippingPolicies(),
    }),
};
